import React from "react";

function FpgDeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      fill="none"
      viewBox="0 0 12 14"
    >
      <path
        fill="#fff"
        d="M3.625 1.875H3.5a.125.125 0 00.125-.125v.125h4.75V1.75c0 .069.056.125.125.125h-.125V3H9.5V1.75a1 1 0 00-1-1h-5a1 1 0 00-1 1V3h1.125V1.875zM11.5 3H.5a.5.5 0 00-.5.5V4c0 .069.056.125.125.125h.944l.386 8.172a1 1 0 00.998.953h7.094a.999.999 0 00.998-.953l.386-8.172h.944A.125.125 0 0012 4v-.5a.5.5 0 00-.5-.5zm-2.073 9.125H2.573l-.378-8h7.61l-.378 8z"
      ></path>
    </svg>
  );
}

export default FpgDeleteIcon;
